export default "./0e6f53e4cfb37e1a5ac014855d17413a.svg";